import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const NotificationsPanelWrapper = styled.div`
	padding: 24px 16px;
	overflow: auto;

	button {
		font-size: 14px;
		font-weight: 600;
		color: ${colors.mainColors.blueberry};

		border: 0;
		background: transparent;

		&:hover {
			text-decoration: underline;
			text-underline-position: under;
		}
	}

	.header {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		gap: 8px;

		.title {
			font-size: 18px;
			color: ${colors.greyscale.black};
			font-weight: 600;
		}
	}

	.notifications {
		margin: 24px 0;

		display: flex;
		flex-direction: column;
		align-items: center;

		gap: 16px;

		> button {
			margin-top: 24px;
		}
	}
`;
